import { render } from "./CommsBrief.vue?vue&type=template&id=75b3f8e9&scoped=true"
import script from "./CommsBrief.vue?vue&type=script&lang=js"
export * from "./CommsBrief.vue?vue&type=script&lang=js"

import "./CommsBrief.vue?vue&type=style&index=0&id=75b3f8e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b3f8e9"]])

export default __exports__